import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {AreaModel} from '../../../../store/control/state';
import {useFilterSelector} from '../../../../hooks/filter-selector';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: AreaModel) => item.id;

export const AREA_TYPES = {
    'floor': 'floor',
    'place': 'place',
};
export const ICON_TYPES = {
    "/images/area/room.png": 'room',
    "/images/area/kid_room.png": 'kid_room',
    "/images/area/bathroom.png": 'bathroom',
    "/images/area/diningroom.png": 'diningroom',
    "/images/area/living.png": 'living',
    "/images/area/kitchen.png": 'kitchen',
    "/images/area/bedroom.png": 'bedroom',
    "/images/area/cellar.png": 'cellar',
    "/images/area/place.png": 'place',
    "/images/area/floor.png": 'floor',
    "/images/area/work_place.png": 'work_place',
    "/images/area/garage.png": 'garage',
    "/images/area/warehouse.png": 'warehouse',
    "/images/area/laundry_room.png":'laundry_room'
};

export const AreaListScreen = memo(function AreaListScreen() {
    const {t} = useLocalization();
    const [selected, setSelected] = useState<AreaModel>(null);

    const areaList = useFilterSelector(
        state => state.control.areaList,
        area => area.type === 'floor' || area.type === 'place',
        [],
    );

    const buttons = useMemo(() => [
        {
            text: t('room_list'),
            className: 'blue',
            url: selected != null ? `/settings/floor/${selected.id}/room` : '',
            hidden: !(selected && selected.type === 'floor'),
        },
        {
            text: t('edit'),
            url: `/settings/area/edit/${selected ? selected.id : ''}`,
            className: 'orange',
            hidden: !(selected),
        },
        {
            text: t('create_area'),
            url: '/settings/area/edit',
            className: 'green',
        },
    ], [t, selected]);

    const displayNameExtractor = useCallback((item: AreaModel, column: ColumnModel) => {
        if (column.key === 'type') {
            return t(AREA_TYPES[item.type]) || '-';
        }
        if (column.key === 'icon_type') {
            return t(ICON_TYPES[item.icon_type]) || '-';
        }

        return item[column.key];
    }, [t]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('area_name'),
            key: 'name',
        },
        {
            length: 3,
            name: t('type'),
            key: 'type',
        },
        {
            length: 3,
            name: t('icon'),
            key: 'icon_type',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='service' isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} backUrl='/settings'>
                <SettingsList
                    columns={columns}
                    items={areaList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selected}
                    onItemSelected={setSelected}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
